<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.el-popper {
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}
.el-scrollbar {
  height: 100% !important;
}
.el-scrollbar__bar {
  &.is-vertical {
    width: 3px !important;
  }
}
.el-scrollbar__wrap {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.el-scrollbar__thumb {
  background: #999999 !important;
}
.el-image {
  vertical-align: top;
}
.labelClass {
  width: 25%;
}
.descriptions-box {
  margin-bottom: 20px;
}
</style>
